// A FOCUSED workspace (api services/workspaceFocus; owner, 31 Oct 2026):
// a Server GTM hosting signup sees Server GTM, its address and its logs, and
// a card for each other part of Cookiebees. Switching a card on adds that
// part's sections to the sidebar. Keys match the API's MODULES.
//
// `paths` are route prefixes: a sidebar row or an address is open in a
// focused workspace when it starts with one of the switched-on cards' paths
// (or with FOCUS_ALWAYS). The same list decides the sidebar and the gate.
import { Activity, Briefcase, Cookie, MessagesSquare, RadioTower, ShoppingBag } from 'lucide-react';

export const ADD_FEATURES_PATH = '/add-features';

// Open in every focused workspace: its one product, the cards, the
// account's settings (team, billing, profile).
export const FOCUS_ALWAYS = ['/server-container', ADD_FEATURES_PATH, '/settings', '/welcome'];

export const WORKSPACE_MODULES = [
  {
    key: 'tracking', icon: Cookie, title: 'First-party tracking',
    line: 'The Cookiebees tag on your own address: every visit, its source and the journey to a sale, kept past Safari and ad blockers.',
    opens: ['Setup', 'Event stream', 'Alerts', 'Event enrichment for your server tags'],
    paths: ['/setup', '/tracking/stream', '/tracking/health', '/tracking/site-scan', '/signal-health', '/integrations'],
  },
  {
    key: 'signals', icon: RadioTower, title: 'Conversions API',
    line: 'Purchases and leads sent to Meta, Google and TikTok from the server, with the customer data they match on.',
    opens: ['Signal catalogue', 'Conversions', 'Number check'],
    paths: ['/studio', '/tracking/conversions', '/number-check', '/value-report', '/integrations'],
  },
  {
    key: 'store', icon: ShoppingBag, title: 'Orders and attribution',
    line: 'Connect your store: every order with the ad behind it, profit, customers and the reports on them.',
    opens: ['Command Center', 'Orders', 'Campaigns', 'Attribution', 'Reports'],
    paths: ['/dashboard', '/growth', '/commerce', '/reports', '/sale-season', '/tracking/repeat-clicks'],
  },
  {
    key: 'leads', icon: Briefcase, title: 'Leads and CRM',
    line: 'Every lead with its source, a pipeline, follow-ups, calls and the forms that bring them in.',
    opens: ['Pipeline', 'Contacts', 'Follow-ups', 'Lead attribution', 'Forms'],
    paths: ['/leads', '/pipelines', '/contacts', '/deals', '/offerings', '/follow-ups', '/tasks', '/calendar', '/meetings',
      '/calls', '/calling-lists', '/cold-captures', '/tracking/attribution', '/forms', '/popups', '/chat', '/scoring'],
  },
  {
    key: 'messaging', icon: MessagesSquare, title: 'WhatsApp and email',
    line: 'One inbox, broadcasts, templates and the automated flows that follow up for you.',
    opens: ['WA Inbox', 'Broadcasts', 'Templates', 'Workflows'],
    paths: ['/whatsapp', '/automation', '/automations', '/integrations/whatsapp', '/tracking/email'],
  },
];

export const MODULE_ICON_FALLBACK = Activity;

const under = (path, prefix) => path === prefix || path.startsWith(`${prefix}/`);

/** Is this address open in a focused workspace with these cards on? */
export function openInFocus(to, modules = []) {
  const path = String(to || '').split('?')[0];
  if (FOCUS_ALWAYS.some((p) => under(path, p))) return true;
  return WORKSPACE_MODULES.some((m) => modules.includes(m.key) && m.paths.some((p) => under(path, p)));
}

/** Where a card's sections start, for "Open" after switching it on. */
export function moduleHome(key) {
  const m = WORKSPACE_MODULES.find((x) => x.key === key);
  return m ? m.paths[0] : '/server-container';
}
